import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewPDF } from "../../utils/viewPDF";
import axios from "axios";
import html2pdf from "html2pdf.js";
import ViewAllBidsTableExport from "./ViewAllBidsTableExport";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import AllBidsTableForPDF from "./AllBidsTableForPDF";
import { handleExportPDF } from "../../utils/exportToPDF";

const ViewRFQ = () => {
  const [rfq, setRfq] = useState();
  const { rfqId } = useParams();
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [itemsLoading, setItemsLoading] = useState(true);
  const [awarded, setAwarded] = useState();
  const [comment, setComment] = useState();
  const [bidData, setBidData] = useState();
  const [groupedData, setGroupedData] = useState();
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const pdfRef = useRef();
  const awardRef = useRef();

  // const handleExportPDF = async () => {
  //   if (!pdfRef.current) {
  //     console.error("PDF content not found");
  //     return;
  //   }

  //   const element = pdfRef.current;

  //   try {
  //     const canvas = await html2canvas(element, {
  //       scale: 2,
  //       useCORS: true,
  //     });

  //     const imgData = canvas.toDataURL("image/png");

  //     const pdf = new jsPDF({
  //       unit: "pt",
  //       format: "a4",
  //       orientation: "portrait",
  //     });

  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = pdf.internal.pageSize.getHeight();

  //     // Calculate the height of the image on the PDF
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const imgWidth = pdfWidth;
  //     const imgHeight = (imgProps.height * pdfWidth) / imgProps.width;

  //     let heightLeft = imgHeight;
  //     let position = 0;

  //     // Add the first page
  //     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //     heightLeft -= pdfHeight;

  //     // Add extra pages if the content is longer than one page
  //     while (heightLeft > 0) {
  //       position = heightLeft - imgHeight;
  //       pdf.addPage();
  //       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
  //       heightLeft -= pdfHeight;
  //     }

  //     pdf.save("RFQ_Details.pdf");
  //   } catch (error) {
  //     console.error("Failed to export PDF", error);
  //   }
  // };

  // const handleExportPDFAwarded = async () => {
  //   const table = awardRef.current;
  //   if (!table) return;

  //   // Save original styles
  //   const originalOverflow = table.style.overflow;
  //   const originalWidth = table.style.width;
  //   const scrollWidth = table.scrollWidth;

  //   // Expand table to full scrollable width
  //   table.style.overflow = "visible";
  //   table.style.width = `${scrollWidth}px`;

  //   await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for reflow

  //   // Take screenshot of full content
  //   const canvas = await html2canvas(table, {
  //     scrollX: -window.scrollX,
  //     scrollY: -window.scrollY,
  //     useCORS: true,
  //   });

  //   // Restore original styles
  //   table.style.overflow = originalOverflow;
  //   table.style.width = originalWidth;

  //   const imgData = canvas.toDataURL("image/png");

  //   // PDF config
  //   const pdf = new jsPDF({
  //     orientation: "landscape",
  //     unit: "px",
  //     format: "a4",
  //   });

  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();

  //   const imgWidth = canvas.width;
  //   const imgHeight = canvas.height;

  //   // Scale the image width to fit the PDF page width
  //   const scale = pageWidth / imgWidth;
  //   const scaledHeight = imgHeight * scale;

  //   let position = 0;

  //   // Add image in chunks (if taller than 1 page)
  //   while (position < scaledHeight) {
  //     const remainingHeight = scaledHeight - position;
  //     const heightOnThisPage = Math.min(pageHeight, remainingHeight);

  //     pdf.addImage(
  //       imgData,
  //       "PNG",
  //       0,
  //       -position, // Crop vertically by shifting image upwards
  //       pageWidth,
  //       scaledHeight
  //     );

  //     position += pageHeight;

  //     if (position < scaledHeight) {
  //       pdf.addPage(); // Add new page if content still remains
  //     }
  //   }

  //   pdf.save("RFQ_Awarded.pdf");
  // };

  useEffect(() => {
    const getRFQ = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/rfq/get-by-id?rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setRfq(res.data);
        setItemsLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getRFQ();
  }, []);

  useEffect(() => {
    const getComment = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/comment?rfqId=${rfqId}&username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setComment(res.data);
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getComment();

    const getBidData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid?username=${storedUser.username}&rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        const allBids = res.data.filter(Boolean);
        setBidData(res.data);
        setGroupedData(groupBidsByVendor(allBids));
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };
    getBidData();

    const getAwarded = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/bid/awarded?rfqId=${rfqId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setAwarded(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getAwarded();
  }, [rfq]);

  const groupedWorkItems = rfq?.rfqWorkItems?.reduce((acc, item) => {
    if (!acc[item.section]) {
      acc[item.section] = [];
    }
    acc[item.section].push(item);
    return acc;
  }, {});

  const groupBidsByVendor = (bids) => {
    const grouped = {};
    bids.forEach((bid) => {
      const name = bid.vendor.name;
      const firmName = bid.vendor.firmName;
      if (!grouped[`${name}-${firmName}`]) {
        grouped[`${name}-${firmName}`] = [];
      }
      grouped[`${name}-${firmName}`].push(bid);
    });
    return grouped;
  };

  const grandTotal =
    rfq &&
    rfq?.rfqWorkItems
      ?.reduce((sum, row) => sum + parseFloat(row.total || 0), 0)
      .toFixed(2);

  const handleBack = () => {
    navigate("/dashboard");
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const [hours, minutes] = time?.split(":") || [];
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const vendorTotals =
    awarded &&
    Object.values(
      awarded.reduce((acc, bid) => {
        const vendorId = bid.vendor.vendorId;

        if (!acc[vendorId]) {
          acc[vendorId] = {
            vendor: bid.vendor,
            totalAmount: 0,
          };
        }

        const baseTotal = bid.bidWorkItems
          .filter((bw) => bw.bidStatus === "AWARDED")
          .reduce((sum, bw) => {
            const percent = bw.percentageAllotted ?? 100; // default 100% if missing
            const allocatedQty = bw.quantity * (percent / 100);
            const allocatedAmount = allocatedQty * bw.rate;
            return sum + allocatedAmount;
          }, 0);

        const calculateExtra = (value, type) => {
          if (!value || !type) return 0;
          if (type === "percentage") {
            return baseTotal * (value / 100);
          }
          return value;
        };

        const packagingExtra = calculateExtra(
          bid.packagingValue,
          bid.packagingType,
        );
        const freightExtra = calculateExtra(bid.freightValue, bid.freightType);
        const creditExtra = calculateExtra(bid.creditValue, bid.creditType);

        acc[vendorId].totalAmount +=
          baseTotal + packagingExtra + freightExtra + creditExtra;

        return acc;
      }, {}),
    );

  const grandTotalAwarded =
    vendorTotals?.reduce((sum, vg) => sum + vg.totalAmount, 0).toFixed(2) || 0;

  return (
    <div>
      {exporting && (
        <div className="uploading-div">
          Exporting PDF... This may take a while.{" "}
          <CircularProgress color="#fff" />
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
        {awarded && awarded.length > 0 && (
          <Button
            className="btn-contained"
            sx={{ width: "200px" }}
            onClick={async () => {
              try {
                setExporting(true);
                await handleExportPDF(awardRef, "RFQ_Awarded");
              } catch (e) {
                console.log(e);
              } finally {
                setExporting(false);
              }
            }}
          >
            Export Awarded PDF
          </Button>
        )}
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true);
              await handleExportPDF(pdfRef, "RFQ_Details");
            } catch (e) {
              console.log(e);
            } finally {
              setExporting(false);
            }
          }}
        >
          Export RFQ PDF
        </Button>
      </div>
      <div ref={pdfRef}>
        <Box className="dashboard-container" px={10}>
          <Typography className="form-title">RFQ Details</Typography>
          <Grid2 container>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderTop: "1px solid #000" }}
            >
              RFQ ID
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderTop: "1px solid #000",
                borderRight: "1px solid #000",
              }}
            >
              {rfq && rfq.rfqId}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Creation Date
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{
                borderRight: "1px solid #000",
              }}
            >
              {rfq && formatDateTime(rfq.creationDate)}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Submission Date
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && formatDateTime(rfq.submissionDate)}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Short Description about RFQ
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.shortDesc}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Comments/Brief about RFQ
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.brief}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Attachments
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.document && (
                <Button
                  sx={{
                    margin: "0 !important",
                    padding: "0 !important",
                    width: "max-content !important",
                    fontSize: "12px !important",
                    textDecoration: "underline",
                    textAlign: "start",
                  }}
                  onClick={() => viewPDF(rfq.document, storedUser)}
                >
                  {rfq.documentFilename}
                </Button>
              )}
            </Grid2>

            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Name
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.name}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Email ID
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.email}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Department
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq.dept}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Delivery period (Lead Time)
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term1}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Payment Terms
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term2}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Freight
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term3}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Price Basis (Incoterms)
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term4}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Warranty Period
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term5}
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
              Late Delivery Clause
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 6 }}
              className="preview-grid"
              sx={{ borderRight: "1px solid #000" }}
            >
              {rfq && rfq?.term6}
            </Grid2>
            {rfq && rfq.rebidStartDate && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Rebid Start Date
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {rfq && formatDateTime(rfq.rebidStartDate)}
                </Grid2>
              </>
            )}
            {rfq && rfq.rebidEndDate && (
              <>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  Rebid End Date
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {rfq && formatDateTime(rfq.rebidEndDate)}
                </Grid2>
              </>
            )}
          </Grid2>
        </Box>

        <h2>Work Items Details</h2>
        <Box className="dashboard-container" px={10}>
          <table
            border={1}
            style={{
              borderCollapse: "collapse",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <thead>
              <tr>
                <th style={{ padding: "20px" }}>Item Code</th>
                <th>Description</th>
                <th>Item Group</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>Rate (in &#8377;)</th>
                <th style={{ width: "100px" }}>PO Rate (in &#8377;)</th>
                <th>PO Number</th>
                <th>SAP PR</th>
                <th>GST (in %)</th>
                <th>Total (in &#8377;)</th>
              </tr>
            </thead>
            <tbody>
              {itemsLoading
                ? "Loading..."
                : groupedWorkItems &&
                  Object.entries(groupedWorkItems).map(
                    ([section, items], sectionIndex) => {
                      const sectionTotal = items.reduce(
                        (sum, item) => sum + item.rate * item.quantity,
                        0,
                      );
                      return (
                        <React.Fragment key={sectionIndex}>
                          <tr
                            style={{
                              backgroundColor: "#d8e9f0",
                              fontWeight: "bold",
                            }}
                          >
                            <td
                              colSpan={10}
                              style={{ textAlign: "left", padding: "10px" }}
                            >
                              {section}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {new Intl.NumberFormat("en-IN", {
                                style: "decimal",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }).format(sectionTotal)}
                            </td>
                          </tr>
                          {items
                            .sort((a, b) => a.itemOrder - b.itemOrder)
                            .map((item, index) => (
                              <tr key={index} style={{ textAlign: "center" }}>
                                <td style={{ padding: "20px" }}>{item.code}</td>
                                <td>{item.description}</td>
                                <td>{item.section}</td>
                                <td>{item.unit}</td>
                                <td>{item.quantity}</td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(item.rate)}
                                </td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(item.poRate)}
                                </td>
                                <td>{item.poNumber}</td>
                                <td>{item.sapPr}</td>
                                <td>{item.gst}</td>
                                <td>
                                  {new Intl.NumberFormat("en-IN", {
                                    style: "decimal",
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }).format(item.rate * item.quantity)}
                                </td>
                              </tr>
                            ))}
                        </React.Fragment>
                      );
                    },
                  )}
              <tr style={{ backgroundColor: "#d8e9f0", fontWeight: "bold" }}>
                <td
                  colSpan={10}
                  style={{ textAlign: "right", paddingRight: "10px" }}
                >
                  Grand Total (in &#8377;):
                </td>
                <td
                  style={{
                    width: "150px",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  {new Intl.NumberFormat("en-IN", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(grandTotal)}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>

        <Box className="dashboard-container" px={10}>
          <Typography variant="h6">Approvers</Typography>
          <Grid2 container>
            {rfq?.rfqApprovers && (
              <React.Fragment>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderTop: "1px solid #000" }}
                >
                  Buyer
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{
                    borderTop: "1px solid #000",
                    borderRight: "1px solid #000",
                  }}
                >
                  {rfq?.buyer?.name || "Loading..."}
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  PURCHASE MANAGER
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{
                    borderRight: "1px solid #000",
                  }}
                >
                  {rfq?.rfqApprovers[0]?.purchaseHead?.name || "Loading..."}
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  FINAL APPROVER 1
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {rfq?.rfqApprovers[0]?.awardee1
                    ? rfq?.rfqApprovers[0]?.awardee1?.name
                    : "N/A" || "Loading..."}
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                  FINAL APPROVER 2
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 6 }}
                  className="preview-grid"
                  sx={{ borderRight: "1px solid #000" }}
                >
                  {rfq?.rfqApprovers[0]?.awardee2?.name || "Loading..."}
                </Grid2>
              </React.Fragment>
            )}
          </Grid2>
        </Box>

        <Box className="dashboard-container" px={10}>
          <Typography variant="h6">Vendors</Typography>
          <Box>
            {(rfq?.vendors || []).map((email, index) => {
              const matchedVendor = rfq?.vendorList?.find(
                (v) => v.email === email,
              );

              return (
                <p key={index}>
                  {email} - {matchedVendor ? matchedVendor.vrStatus : "PENDING"}
                </p>
              );
            })}
          </Box>
        </Box>
        {awarded && awarded.length > 0 && (
          <Box className="dashboard-container" px={10} mt={4}>
            <Typography variant="h6">Awarded Quotes</Typography>

            {awarded && awarded.length > 0 ? (
              Object.values(
                awarded.reduce((acc, bid) => {
                  const vendorId = bid.vendor.vendorId;
                  if (!acc[vendorId]) {
                    acc[vendorId] = { vendor: bid.vendor, bids: [] };
                  }
                  acc[vendorId].bids.push(bid);
                  return acc;
                }, {}),
              ).map((vendorGroup) => {
                let totalAmountWithTax = 0;
                return (
                  <Box key={vendorGroup.vendor.vendorId} mt={3}>
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 1, fontWeight: "bold" }}
                    >
                      Vendor: {vendorGroup.vendor.name} (
                      {vendorGroup.vendor.firmName})
                    </Typography>
                    <table
                      border={1}
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ padding: "20px" }}>Code</th>
                          <th>Description</th>
                          <th>Qty</th>
                          <th>Rate (in ₹)</th>
                          <th>GST (in %)</th>
                          <th>Percentage Allotted</th>
                          <th>Amount (Excl. GST)</th>
                          <th>Tax (in ₹)</th>
                          <th>Amount (Incl. GST)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendorGroup.bids.map((bid) =>
                          bid.bidWorkItems
                            .filter((bw) => bw.bidStatus === "AWARDED")
                            .sort((a, b) => a.itemOrder - b.itemOrder)
                            .map((bw) => {
                              const percent = bw.percentageAllotted || 0;
                              const allocatedQty =
                                bw.quantity * (percent / 100);
                              const allocatedAmount = allocatedQty * bw.rate;
                              const taxAmount =
                                allocatedAmount * (bw.gst / 100);
                              const amountWithTax = allocatedAmount + taxAmount;
                              totalAmountWithTax += amountWithTax || 0;
                              return (
                                <tr
                                  key={bw.bwId}
                                  style={{ textAlign: "center" }}
                                >
                                  <td style={{ padding: "20px" }}>{bw.code}</td>
                                  <td>{bw.description}</td>
                                  <td>{allocatedQty}</td>
                                  <td>
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "decimal",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(bw.rate)}
                                  </td>
                                  <td>{bw.gst}</td>
                                  <td>{bw.percentageAllotted}</td>
                                  <td>
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "decimal",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(allocatedAmount)}
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "decimal",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(taxAmount)}
                                  </td>
                                  <td>
                                    {new Intl.NumberFormat("en-IN", {
                                      style: "decimal",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }).format(amountWithTax)}
                                  </td>
                                </tr>
                              );
                            }),
                        )}
                        <tr
                          style={{
                            fontWeight: "bold",
                            backgroundColor: "#e0f7fa",
                          }}
                        >
                          <td
                            colSpan={8}
                            style={{ padding: "20px", textAlign: "right" }}
                          >
                            Grand Total (in ₹):
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {totalAmountWithTax.toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>
                );
              })
            ) : (
              <Typography>No awarded bids available.</Typography>
            )}
          </Box>
        )}

        {comment && rfq?.status === "AWARDED" && (
          <Box className="dashboard-container" px={10}>
            <Typography variant="h6">Comments</Typography>
            <table
              border="1"
              cellPadding="20px"
              cellSpacing="0"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#e0f7fa", fontWeight: "bold" }}>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Date</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                {comment.map((c, index) => (
                  <tr key={index}>
                    <td>{c.orgUser?.name || "—"}</td>
                    <td>{c.orgUser?.userRoleName.replace("_", " ") || "—"}</td>
                    <td>
                      {new Date(c.createdDate).toLocaleString("en-IN", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })}
                    </td>
                    <td>{c.comment || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        )}
      </div>
      {awarded && awarded.length > 0 && (
        <div
          ref={awardRef}
          style={{
            position: "absolute",
            top: "-9999px",
            left: "-9999px",
            height: "auto",
            width: "auto",
            paddingInline: "5px",
          }}
        >
          <Box>
            <Box py={3}>
              <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                RFQ Details:{" "}
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                <b>Short Description:</b> {rfq && rfq.shortDesc}
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                <b>Name:</b> {rfq && rfq.name}
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                <b>Email ID:</b> {rfq && rfq.email}
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                <b>Department:</b> {rfq && rfq.dept}
              </Typography>
              <Typography sx={{ fontSize: "14px" }}>
                <b>Creation Date:</b> {rfq && formatDateTime(rfq.creationDate)}
              </Typography>
            </Box>
            {comment && rfq?.status === "AWARDED" && (
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Comments
                </Typography>
                <table
                  border="1"
                  cellSpacing="0"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      style={{ backgroundColor: "#e0f7fa", fontWeight: "bold" }}
                    >
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Date</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {comment.map((c, index) => (
                      <tr key={index}>
                        <td>{c.orgUser?.name || "—"}</td>
                        <td>
                          {c.orgUser?.userRoleName.replace("_", " ") || "—"}
                        </td>
                        <td>
                          {new Date(c.createdDate).toLocaleString("en-IN", {
                            dateStyle: "medium",
                            timeStyle: "short",
                          })}
                        </td>
                        <td>{c.comment || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            )}

            {!loading && (
              <Box pt={3}>
                <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                  Item Group wise Summary
                </Typography>
                <AllBidsTableForPDF
                  rfq={rfq}
                  bidData={bidData}
                  groupedData={groupedData}
                  groupedWorkItems={groupedWorkItems}
                  storedUser={storedUser}
                />
              </Box>
            )}
            <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
              Awarded
            </Typography>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "8px",
                fontSize: "12px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "left",
                    }}
                  >
                    Awarded
                  </th>
                  <th
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "right",
                    }}
                  >
                    Amount (₹)
                  </th>
                </tr>
              </thead>
              <tbody>
                {vendorTotals.map((vendorGroup) => (
                  <tr key={vendorGroup.vendor?.vendorId}>
                    <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                      {vendorGroup.vendor?.name} ({vendorGroup.vendor?.firmName}
                      )
                    </td>
                    <td
                      style={{
                        border: "1px solid #ccc",
                        padding: "8px",
                        textAlign: "right",
                      }}
                    >
                      ₹
                      {new Intl.NumberFormat("en-IN", {
                        style: "decimal",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(vendorGroup.totalAmount)}
                    </td>
                  </tr>
                ))}

                <tr>
                  <td
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    Total
                  </td>
                  <td
                    style={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                  >
                    ₹
                    {new Intl.NumberFormat("en-IN", {
                      style: "decimal",
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }).format(grandTotalAwarded)}
                  </td>
                </tr>
              </tbody>
            </table>
          </Box>
        </div>
      )}

      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewRFQ;
